module.exports = __webpack_public_path__ + "static/media/svg icons-01.7815b912.svg";